import React from 'react';
import { SKILLS } from '../../data';
import { Reveal } from '../ui/Reveal';
import { SectionHeader } from '../ui/SectionHeader';

export const Skills: React.FC = () => (
  <section id="skills">
    <div className="section-wrap">
      <SectionHeader
        label="Skills"
        title={<>The full <em>toolkit.</em></>}
      />

      <div className="skills-grid">
        {SKILLS.map((group, i) => (
          <Reveal key={group.title} delay={i * 55}>
            <div className="skill-card">
              <div className="sk-cat">{group.title}</div>
              <div className="tag-wrap">
                {group.items.map((skill) => (
                  <span key={skill} className="tag">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
